import React from "react";

import SmartImage from "@/shared/ui/smart-image";

import "@/shared/ui/data-display/tags/style/tag-base.scss";

export interface TagBaseProps extends Tag {
    onClick: (value: string) => void;
    className?: string;
}

export interface Tag {
    label: string;
    value: string;
    active?: boolean;
    icon?: string;
}

export const TagBase: React.FC<TagBaseProps> = ({label, icon, active = false, value, onClick, className = ""}) => {
    const handleTag = (): void => {
        if (onClick) {
            onClick(value);
        }
    };

    return (
        <button className={`tag-base ${active ? "tag-base--active" : ""} ${className}`} onClick={handleTag} type="button">
            {icon && (
                <span className="tag-base__icon">
                    <SmartImage src={icon} alt={label} width={16} height={16} />
                </span>
            )}
            <span className="tag-base__text">{label}</span>
        </button>
    );
};
